<template>
  <div>
    <UserActionsWrap form-title="Log in<br> to your account">
      <LoginForm />
    </UserActionsWrap>
    <UserActionsNavigation />
  </div>
</template>

<script>
  import UserActionsWrap from "../components/UserActionsWrap";
  import LoginForm from "../components/LoginForm";
  import UserActionsNavigation from "../components/UserActionsNavigation";

  export default {
    name: "Registration",
    components: {
      UserActionsWrap,
      LoginForm,
      UserActionsNavigation
    }
  }
</script>
